import { GenericService } from "@/services/GenericService";
import {
  CountryDTO,
  CourierDTO,
  CurrenciesDTO,
  MbePackTypeDTO,
  MbeServiceDTO,
  MeasurementUnitsDTO,
  PaymentTypesDTO,
  SubcountryDTO
} from "@/model/data.model";
import { PriceListService } from "@/services/PriceListService";
import { ShipmentService } from "@/services/ShipmentService";

// initial state
const state = {
  timeouts: {
    subCountries: 600000,
    mbeServices: 600000,
    packageTypes: 600000,
    couriersByServices: 600000,
    paymentTypes: 600000
  }
};

// getters
const getters = {};

// actions
const actions = {
  getCurrentDate(): Promise<any> {
    return GenericService.prototype.getStoreDate();
  },
  getCountries(): Promise<CountryDTO[]> {
    return GenericService.getCountries();
  },
  getMeasurementUnits(): Promise<MeasurementUnitsDTO[]> {
    return GenericService.getMeasurementUnits();
  },
  getProformaMeasurementUnits(): Promise<MeasurementUnitsDTO[]> {
    return GenericService.getProformaMeasurementUnits();
  },
  getCurrencies(): Promise<CurrenciesDTO[]> {
    return GenericService.getCurrencies();
  },
  getSubcountries(
    { commit },
    { countryId, zipcode, storeZipCode, storeIsoCode }
  ): Promise<SubcountryDTO[]> {
    return PriceListService.getSubcountries(
      countryId,
      zipcode,
      storeZipCode,
      storeIsoCode
    );
  },
  getAddressDistance({ commit }, { addressFrom, addressTo }) {
    return ShipmentService.prototype.distanceMatrix(addressFrom, addressTo);
  },
  getSpecificPackTypes({ commit }, { courierId }) {
    return ShipmentService.prototype.getSpecificPackTypes(courierId);
  },
  getHandlingInstructions() {
    return ShipmentService.prototype.getHandlingInstructions();
  },
  getAllSubcountries(): Promise<SubcountryDTO[]> {
    return PriceListService.getAllSubCountries();
  },
  getMbeServiceForCourierService(
    { commit },
    { idBusinessCourierService, cancelToken }
  ): Promise<MbeServiceDTO[]> {
    return PriceListService.getMbeServiceForCourierService(
      idBusinessCourierService,
      cancelToken
    );
  },
  getMbePackTypes(): Promise<MbePackTypeDTO[]> {
    return PriceListService.getMbePackTypes();
  },
  couriersByServices(
    { commit },
    { subFromId, subToId, shipType, idBusinessMBEService, courierServiceIds }
  ): Promise<CourierDTO[]> {
    return PriceListService.couriersByServices(
      subFromId,
      subToId,
      shipType,
      idBusinessMBEService,
      courierServiceIds
    );
  },
  courierServices(
    { commit },
    {
      idCourier,
      subcountryFromId,
      subcountryToId,
      shipmentType,
      courierPackageType,
      mbeService,
      cancelSource,
      autopilot
    }
  ): Promise<any> {
    return PriceListService.getCourierServices(
      idCourier,
      subcountryFromId,
      subcountryToId,
      shipmentType,
      courierPackageType,
      mbeService,
      cancelSource,
      autopilot
    );
  },
  getCourierPackageTypes(
    { commit },
    {
      idCourier,
      subcountryFromId,
      subcountryToId,
      shipmentType,
      MBEServiceId,
      idMBEBusiness,
      idMBEPackType
    }
  ): Promise<any> {
    return PriceListService.getCourierPackageTypes(
      idCourier,
      subcountryFromId,
      subcountryToId,
      shipmentType,
      MBEServiceId,
      idMBEBusiness,
      idMBEPackType
    );
  },
  getPaymentTypes(
    { commit },
    { idBusinessCourier, extraServiceId }
  ): Promise<PaymentTypesDTO[]> {
    return PriceListService.getPaymentTypes(idBusinessCourier, extraServiceId);
  }
};

// mutations
const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
